import { ChangeDetectionStrategy, Component, Input } from "@angular/core";

@Component({
	selector: "ic-not-found",
	styleUrls: ["./not-found.component.scss"],
	templateUrl: "./not-found.component.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class NotFoundComponent {
	@Input() title?: string;
}
